export default "__VITE_ASSET__BVxPJyIN__"